// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_SimpleFilter.scss
// module id = 524
// module chunks = 36 88